export const SET_DECLINED_SERVICES = 'SET_DECLINED_SERVICES';
export const CLEAR_SERVICES = 'CLEAR_SERVICES';



// WEBPACK FOOTER //
// ./src/store/reducers/declined/actionTypes.js